import { Navigate, Route, Routes } from "react-router";
import IndustryHome from "./Home";
import IndustryExperiences from "./Experiences";
import "./index.css"
export default function Industry() {
    return(
        <div id="wd-Industry" className="row align-items-start me-2 ms-4 pb-2">
        <div className="col-sm-1 col-md-1 col-lg-1">
        </div>
        <div className="col-sm-10 col-md-10 col-lg-10 responsive-align-top">
        <Routes>
            <Route path="/" element={<IndustryHome/> } />
            <Route path=":eid/*" element={<IndustryExperiences/>} />
        </Routes>
        </div>
        <div className="col-sm-1 col-md-1 col-lg-1 mb-3">
        </div>
        </div>
        
    );
}